import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-53f17606"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-link" }

import { Icon } from '../../Atoms';


export default /*#__PURE__*/_defineComponent({
  __name: 'InteractiveMapLink',
  props: {
    link: {},
    icon: {}
  },
  setup(__props: any) {

const props = __props;

const routeToMap = () => {
  window.location.href = props.link;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.$t('Not Sure?')) + " ", 1),
    _createElementVNode("a", { onClick: routeToMap }, [
      _createTextVNode(_toDisplayString(_ctx.$t('Explore our interactive map')) + " ", 1),
      _createVNode(_unref(Icon), {
        "icon-name": _ctx.icon,
        sm: ""
      }, null, 8, ["icon-name"])
    ])
  ]))
}
}

})